export const CAI_CHAT_FLOWS = {
  DEFAULT: 'main',
  FEEDBACK: 'feedback',
  LIBRARIAN: 'librarian',
  SESSION: 'session',
  GOALS: 'goals',
}
